import { RcFile } from "antd/es/upload";
import { envs } from "application/envHandler";
import apiClient from 'core/api';
import { AxiosConfigurationFilesResponse } from "./types";

export async function fetchConfigurationFiles() {
  return apiClient.get('/rtf/config-files', {
    baseURL: envs.REACT_APP_API_URL,
  }) as Promise<AxiosConfigurationFilesResponse>
}

export async function downloadConfigurationFile(fileName: string) {
  return apiClient.get(`/rtf/config-files/${encodeURIComponent(fileName)}`, {
    baseURL: envs.REACT_APP_API_URL,
    responseType: 'blob',
  })
}

export async function uploadConfigurationFile(file: RcFile) {
  return apiClient.put(`${envs.REACT_APP_API_URL}/rtf/config-files/${encodeURIComponent(file.name)}`, file, {
    headers: { 'Content-Type': 'application/octet-stream' },
  })
}

export async function deleteConfigurationFile(fileName: string) {
  return apiClient.delete(`/rtf/config-files/${encodeURIComponent(fileName)}`, undefined, {
    baseURL: envs.REACT_APP_API_URL,
  })
}
